export default function findNeighbouringEnemies(
  state: string[][],
  row: number,
  column: number,
  target: string
): number[][] {
  const neighbours = [
    [0, 1],
    [1, 0],
    [0, -1],
    [-1, 0],
  ];

  return neighbours.filter(([r, c]) => {
    const _row = r + row;
    const _column = c + column;
    return (
      _row >= 0 &&
      _row < 11 &&
      _column >= 0 &&
      _column < 11 &&
      target.includes(state[_row][_column])
    );
  });
}
